import {
  clearObject
} from "./chunk-X7Z2OBKV.js";

// src/cnp_tag.ts
var CnpTagType = /* @__PURE__ */ ((CnpTagType2) => {
  CnpTagType2["DESCRIPTOR"] = "descriptor";
  CnpTagType2["EVENT"] = "event";
  CnpTagType2["LOCATION"] = "location";
  CnpTagType2["ORGANIZATION"] = "organization";
  CnpTagType2["PERSON"] = "person";
  CnpTagType2["INTEREST"] = "interest";
  CnpTagType2["MACHINE"] = "machine";
  return CnpTagType2;
})(CnpTagType || {});
var getTag = (client, provider) => async (id, options) => {
  return await client.get(`${provider}/tags/${id}`, options).json();
};
var searchTags = (client, provider) => async (query, options) => {
  return await client.get(`${provider}/tags/search/${query}`, options).json();
};
var getProfiles = (client, provider) => async (categoryId, options) => {
  return await client.get(`${provider}/tags/profiles`, {
    searchParams: clearObject({ categoryId }),
    ...options
  }).json();
};
var getEnrichments = (client, provider) => async (options) => {
  return await client.get(`${provider}/tags/enrichments`, options).json();
};
var getEnrichment = (client, provider) => async (id, options) => {
  return await client.get(`${provider}/tags/enrichments/${id}`, options).json();
};
var createEnrichment = (client, provider) => async (data, options) => {
  return await client.post(`${provider}/tags/enrichments`, { json: data, ...options }).json();
};
var updateEnrichment = (client, provider) => async (id, data, options) => {
  return await client.patch(`${provider}/tags/enrichments/${id}`, { json: data, ...options }).json();
};
var createTagApi = (client, provider) => {
  return {
    getTag: getTag(client, provider),
    searchTags: searchTags(client, provider),
    getProfiles: getProfiles(client, provider),
    getEnrichments: getEnrichments(client, provider),
    getEnrichment: getEnrichment(client, provider),
    createEnrichment: createEnrichment(client, provider),
    updateEnrichment: updateEnrichment(client, provider)
  };
};

export {
  CnpTagType,
  createTagApi
};
